"use client";

import ElevenMusic20 from "@ui/icons/20x20/eleven-music-20.svg";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

interface PremiumLoadingIndicatorProps {
  className?: string;
}

export function PremiumLoadingIndicator({ className = "" }: PremiumLoadingIndicatorProps) {
  const t = useTranslations("ClientKeys.VideoToMusic");
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  const loadingMessages = [
    t("loading_message_watching"),
    t("loading_message_thinking"),
    t("loading_message_composing"),
    t("loading_message_choosing_instruments"),
    t("loading_message_final_touches"),
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex(prev => (prev + 1) % loadingMessages.length);
    }, 2_500);

    return () => clearInterval(interval);
  }, [loadingMessages.length]);

  return (
    <div className={`flex h-full flex-col items-center justify-between p-24 ${className}`}>
      <div />

      <div className='flex flex-col items-center gap-32'>
        <div className='flex h-40 w-40 items-center justify-center'>
          <ElevenMusic20 />
        </div>

        <div className='text-center'>
          <p className='shimmer-text'>{loadingMessages[currentMessageIndex]}</p>
        </div>
      </div>

      <p className='text-gray-400 text-sm'>{t("estimated_time")}</p>
    </div>
  );
}
